export default "__VITE_ASSET__CF4Gl1P6__"